import React, { useState, useRef, useImperativeHandle } from 'react';
import { FocusEvent,KeyboardEvent, MouseEvent } from 'react'
import { makeStyles } from '@mui/styles';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { MenuProps } from '@mui/material/Menu';
import ArrowLeft from '@mui/icons-material/ArrowLeft';
import clsx from 'clsx';
import { number } from 'prop-types';
const TRANSPARENT = 'rgba(0,0,0,0)';
const useMenuItemStyles = makeStyles((theme) => ({
    root: (props) => ({
        backgroundColor:'white',
        color: "red"
    })

}));
/**
 * Use as a drop-in replacement for `<MenuItem>` when you need to add cascading
 * menu elements as children to this component.
 */
const NestedMenuItem = React.forwardRef(function NestedMenuItem (props:{parentMenuOpen: boolean,
                                                                 component: React.ElementType,
                                                                label: React.ReactNode,
                                                                leftIcon?:React.ReactNode,
                                                                tabIndexProp: number,
                                                                ContainerProps?: React.HTMLAttributes<HTMLElement> & React.RefAttributes<HTMLElement | null>,
                                                                children: any,
                                                                className:any,
                                                                tabIndex: any,
                                                                MenuProps?: Omit<MenuProps, 'children'>,
                                                                disabled: boolean }, ref) {
    const { parentMenuOpen , component = 'div', label, leftIcon = React.createElement(ArrowLeft, null),
    children, className, tabIndex: tabIndexProp, MenuProps = {}, ContainerProps: ContainerPropsProp = {}, ...MenuItemProps } = props;
    const { ref: containerRefProp, ...ContainerProps } = ContainerPropsProp;
    const menuItemRef = useRef(null);
    useImperativeHandle(ref, () => menuItemRef.current);
    const containerRef = useRef<HTMLElement>(null);

    useImperativeHandle(containerRefProp as React.Ref<HTMLElement | null>, () => containerRef.current);
    const menuContainerRef = useRef(null);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    const handleMouseEnter = (event:MouseEvent<HTMLInputElement>) => {
        let _a;
        setIsSubMenuOpen(true);
        if ((_a = ContainerProps) === null || _a === void 0 ? void 0 : _a.onMouseEnter) {
            ContainerProps.onMouseEnter?.(event);}

    };
    const handleMouseLeave = (event:MouseEvent<HTMLInputElement>) => {
        let _a;
        setIsSubMenuOpen(false);
        if ((_a = ContainerProps) === null || _a === void 0 ? void 0 : _a.onMouseLeave) {
            ContainerProps.onMouseLeave?.(event);
        }
    };
    // Check if any immediate children are active
    const isSubmenuFocused = () => {
        let _a, _b, _c, _d;
        const active = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : (_a as any).ownerDocument) === null || _b === void 0 ? void 0 : _b.activeElement;
        for (const child of (_d = (_c = menuContainerRef.current) === null || _c === void 0 ? void 0 : (_c as any).children, (_d !== null && _d !== void 0 ? _d : []))) {
            if (child === active) {
                return true;
            }
        }
        return false;
    };
    const handleFocus = (event:FocusEvent<HTMLInputElement>) => {
        let _a;
        if (event.target === containerRef.current) {
            setIsSubMenuOpen(true);
        }
        if ((_a = ContainerProps) === null || _a === void 0 ? void 0 : _a.onFocus) {
            ContainerProps.onFocus?.(event);
        }
    };
    const handleKeyDown = (event:KeyboardEvent<HTMLImageElement>) => {
        let _a, _b, _c, _d, _e;
        if (event.key === 'Escape') {
            return;
        }
        if (isSubmenuFocused()) {
            event.stopPropagation();
        }
        const active = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : (_a as any).ownerDocument) === null || _b === void 0 ? void 0 : _b.activeElement;
        if (event.key === 'ArrowLeft' && isSubmenuFocused()) {
            (_c = containerRef.current) === null || _c === void 0 ? void 0 : (_c as any).focus();
        }
        if (event.key === 'ArrowLeft' &&
            event.target === containerRef.current &&
            event.target === active) {
            const firstChild = (_d = menuContainerRef.current) === null || _d === void 0 ? void 0 : (_d as any).children[0];
            (_e = firstChild) === null || _e === void 0 ? void 0 : _e.focus();
        }
    };
    const open = isSubMenuOpen && parentMenuOpen;
    const menuItemClasses = useMenuItemStyles({ open });
    // Root element must have a `tabIndex` attribute for keyboard navigation
    let tabIndex;
    if (!props.disabled) {
        tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    }
    return (React.createElement("div", Object.assign({}, ContainerProps, { ref: containerRef, onFocus: handleFocus, tabIndex: tabIndex, onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, onKeyDown: handleKeyDown }),
        React.createElement(MenuItem, Object.assign({}, MenuItemProps, { className: clsx({[menuItemClasses.root]: true}), ref: menuItemRef }),
        leftIcon,
        label
           ),
        React.createElement(Menu
        // Set pointer events to 'none' to prevent the invisible Popover div
        // from capturing events for clicks and hovers
        , {
            // Set pointer events to 'none' to prevent the invisible Popover div
            // from capturing events for clicks and hovers
            style: { pointerEvents: 'none' }, anchorEl: menuItemRef.current, anchorOrigin: {
                vertical: 'top',
                horizontal: 'left'
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }, open: open, autoFocus: false, disableAutoFocus: true, disableEnforceFocus: true, onClose: () => {
                setIsSubMenuOpen(false);
            } },
            React.createElement("div", { ref: menuContainerRef, style: { pointerEvents: 'auto' } }, children))));
});
export default NestedMenuItem;
